async function geoblock() {
  const url = window.location.origin + '/browsing_context_suggestions.json';
  const obj = await (await fetch(url)).json();
  // Lowercasing the locale as we will lowercase + cleanse the locales from the tag to ensure we account for any data entry human errors
  const locale = obj.detected_values.country.handle.toLowerCase();

  const productContainer = document.querySelector('.product-template__container');
  const submitDiv = document.querySelector('.product-form__controls-group--submit');

  const geoblockString = productContainer.dataset.geoblock.replace('geoblock:', '').trim().toLowerCase();
  const geoblockArray = geoblockString.split('-').map(element => element.replace(/\s+/g, ''));
  const geoallowString = productContainer.dataset.geoallow.replace('geoallow:', '').trim().toLowerCase();
  const geoallowArray = geoallowString.split('-').map(element => element.replace(/\s+/g, ''));

  const disableAddToCart = () => {
    const atcButton = submitDiv.querySelector('.product-form__cart-submit');
    const buyNowButton = submitDiv.querySelector('.shopify-payment-button');
    const sizesAccordion = document.getElementById('product__accordion--sizes');
    const geoblockDisclaimer = document.querySelector('.product-form__geoblock-message');
    sizesAccordion.remove();
    buyNowButton.remove();
    geoblockDisclaimer.classList.remove('hide');
    atcButton.setAttribute('disabled', true);
    atcButton.style.backgroundColor = "#D6D6D6";
    atcButton.style.borderColor = "#D6D6D6";
    atcButton.style.opacity = "1";
  }

  geoblockArray.includes(locale) && !geoallowArray.includes(locale) && disableAddToCart();
}

geoblock();